<template>
  <div class="similar-movies">
    <div class="similar-movies__header">
      <div class="similar-movies__title-wrapper">
        <div class="similar-movies__title">
          {{ contentType === 'tv' ? 'Similar TV Shows' : 'Similar Movies' }}</div>
        <div class="similar-movies__more" @click="viewMore">
          <div class="similar-movies__more-text">More</div>
          <div class="similar-movies__more-icon">
            <img class="similar-movies__more-arrow" src="@/assets/icon/arrow_right_alt.svg" />
          </div>
        </div>
      </div>
      <div class="similar-movies__controls">
        <div class="similar-movies__control similar-movies__control--prev"
          :class="{ 'similar-movies__control--disabled': !hasPrev }" @click="prevSlide">
          <svg xmlns="http://www.w3.org/2000/svg" class="similar-movies__control-arrow" width="6"
            height="12" viewBox="0 0 6 12" fill="none">
            <path
              d="M1.56641 6.00382L5.79139 1.35876C5.9351 1.20076 6.00456 1.0138 5.99977 0.797876C5.99498 0.581949 5.92073 0.394988 5.77702 0.236993C5.63332 0.0789977 5.46326 0 5.26686 0C5.07046 0 4.90041 0.0789977 4.7567 0.236993L0.344896 5.10325C0.229931 5.22965 0.143707 5.37184 0.0862241 5.52984C0.0287414 5.68783 0 5.84583 0 6.00382C0 6.16182 0.0287414 6.31981 0.0862241 6.47781C0.143707 6.6358 0.229931 6.778 0.344896 6.9044L4.77107 11.7707C4.91478 11.9286 5.08244 12.005 5.27405 11.9997C5.46566 11.9945 5.63332 11.9128 5.77702 11.7549C5.92073 11.5969 5.99258 11.4099 5.99258 11.194C5.99258 10.978 5.92073 10.7911 5.77702 10.6331L1.56641 6.00382Z"
              fill="white" />
          </svg>
        </div>
        <div class="similar-movies__control similar-movies__control--next"
          :class="{ 'similar-movies__control--disabled': !hasNext }" @click="nextSlide">
          <svg xmlns="http://www.w3.org/2000/svg" class="similar-movies__control-arrow"
            viewBox="0 0 6 12" fill="none">
            <path
              d="M4.43359 6.00382L0.208607 1.35876C0.0649 1.20076 -0.00455845 1.0138 0.000231786 0.797876C0.00502202 0.581949 0.0792707 0.394988 0.222978 0.236993C0.366685 0.0789977 0.536738 0 0.733138 0C0.929537 0 1.09959 0.0789977 1.2433 0.236993L5.6551 5.10325C5.77007 5.22965 5.85629 5.37184 5.91378 5.52984C5.97126 5.68783 6 5.84583 6 6.00382C6 6.16182 5.97126 6.31981 5.91378 6.47781C5.85629 6.6358 5.77007 6.778 5.6551 6.9044L1.22893 11.7707C1.08522 11.9286 0.917562 12.005 0.725952 11.9997C0.534343 11.9945 0.366685 11.9128 0.222978 11.7549C0.0792707 11.5969 0.00741714 11.4099 0.00741714 11.194C0.00741714 10.978 0.0792707 10.7911 0.222978 10.6331L4.43359 6.00382Z"
              fill="white" />
          </svg>
        </div>
      </div>
    </div>
    <div class="similar-movies__slider">
      <div class="similar-movies__slider-container" ref="sliderContainer">
        <div v-for="(movie, index) in movies" :key="index" class="similar-movies__card"
          @click="goToDetail(movie)">
          <div class="similar-movies__card-poster">
            <img class="similar-movies__card-img" :src="movie.poster" alt="" />
            <div class="similar-movies__card-overlay"></div>
            <div class="similar-movies__card-info">
              <div class="similar-movies__card-meta">
                <div class="similar-movies__card-rating">
                  <img class="similar-movies__card-star" src="@/assets/icon/star.svg" />
                  <div class="similar-movies__card-score">{{ Number(movie.score).toFixed(1) }}</div>
                </div>
                <div class="similar-movies__card-separator"></div>
                <div class="similar-movies__card-source">{{ movie.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimilarMovies',
  props: {
    movies: {
      type: Array,
      default: () => []
    },
    contentType: {
      type: String,
      default: 'movie', // 默认为电影类型，可选值：'movie' 或 'tv'
      validator: (value) => ['movie', 'tv'].includes(value)
    }
  },
  data () {
    return {
      currentIndex: 0,
      visibleItems: 5,
      totalItems: 0
    };
  },
  computed: {
    hasPrev () {
      return this.currentIndex > 0;
    },
    hasNext () {
      return this.currentIndex + this.visibleItems < this.totalItems;
    }
  },
  watch: {
    movies: {
      immediate: true,
      handler (newVal) {
        this.totalItems = newVal.length;
      }
    }
  },
  methods: {
    viewMore () {
      // 根据内容类型跳转到不同的页面
      if (this.contentType === 'tv') {
        this.$router.push('/tv-shows/popular-tv-shows');
      } else {
        this.$router.push('/movies/popular-movies');
      }
    },
    prevSlide () {
      if (this.hasPrev) {
        this.currentIndex--;
        this.scrollSlider();
      }
    },
    nextSlide () {
      if (this.hasNext) {
        const container = this.$refs.sliderContainer;
        if (container) {
          const cardWidth = container.querySelector('.similar-movies__card').offsetWidth;
          const gapWidth = parseInt(window.getComputedStyle(container).getPropertyValue('gap'));
          const sliderWidth = this.$el.querySelector('.similar-movies__slider').offsetWidth;

          // 如果是最后几个元素，确保显示到最后一个
          if (this.currentIndex + this.visibleItems + 1 >= this.totalItems) {
            // 计算可以显示的最大索引，确保最后一个卡片完全可见
            const maxIndex = this.totalItems - Math.floor(sliderWidth / (cardWidth + gapWidth));
            this.currentIndex = Math.max(0, maxIndex);
          } else {
            this.currentIndex++;
          }
          this.scrollSlider();
        }
      }
    },
    scrollSlider () {
      const container = this.$refs.sliderContainer;
      if (container) {
        const cardWidth = container.querySelector('.similar-movies__card').offsetWidth;
        const gapWidth = parseInt(window.getComputedStyle(container).getPropertyValue('gap'));

        // 获取左侧padding值
        const sliderElement = this.$el.querySelector('.similar-movies__slider');
        const leftPadding = parseInt(window.getComputedStyle(sliderElement).getPropertyValue('padding-left'));

        let translateX = 0;
        if (this.currentIndex === 0) {
          // 第一个位置，不需要偏移
          translateX = 0;
        } else if (this.currentIndex === 1) {
          // 第一次滚动，需要考虑左侧padding
          translateX = leftPadding + cardWidth + gapWidth;
        } else {
          // 后续滚动，考虑第一张卡片和左侧padding，以及后续的卡片和间距 间距是两侧的 所以要加两遍
          translateX = leftPadding + cardWidth + gapWidth + (this.currentIndex - 1) * (cardWidth + gapWidth);
        }

        container.style.transform = `translateX(-${translateX}px)`;
      }
    },
    goToDetail (movie) {
      // 添加类型信息
      const isTV = this.contentType === 'tv';

      // 格式化名称为URL友好的格式
      const formattedName = isTV && movie.name ?
        movie.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]/g, '') :
        movie.title ? movie.title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]/g, '') : 'content';

      // 准备保存到本地存储的数据
      const contentData = {
        id: movie.id,
        title: isTV ? movie.name : movie.title,
        poster: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face/${movie.poster_path}`,
        genres: movie.genre_ids ? movie.genre_ids.map(id => {
          const genreList = isTV ? this.tvGenres : this.movieGenres;
          const genre = genreList.find(g => g.id === id);
          return genre ? genre.name : '';
        }).filter(Boolean) : [],
        score: movie.vote_average,
        date: isTV ? movie.first_air_date : movie.release_date,
        description: movie.overview,
        type: this.contentType // 设置内容类型
      };

      // 将数据存储到localStorage，以便在详情页中使用
      localStorage.setItem('selectedMovie', JSON.stringify(contentData));

      // 构建详情页URL
      const contentPath = isTV ? 'tv-shows' : 'movies';
      const detailUrl = `/${contentPath}/${movie.id}-${formattedName}/`;

      // 跳转到详情页
      this.$router.push(detailUrl);
    }
  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.similar-movies {
	padding: 0 0 rem(44) 0;
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;

	&__header {
		padding: 0 rem(80);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
		width: 100%;
	}

	&__title-wrapper {
		display: flex;
		flex-direction: row;
		gap: rem(24);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__title {
		color: #ffffff;
		text-align: left;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		position: relative;
	}

	&__more {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		position: relative;
		cursor: pointer;
	}

	&__more-text {
		color: #fe324b;
		text-align: left;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
		position: relative;
	}

	&__more-icon {
		width: rem(16);
		height: rem(12);
		position: relative;
	}

	&__more-arrow {
		width: 100%;
		overflow: visible;
	}

	&__controls {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-end;
		position: relative;
	}

	&__control {
		width: rem(28);
		height: rem(28);
		position: relative;
		cursor: pointer;

		&::before {
			content: '';
			background: #ffffff;
			border-radius: 100px;
			opacity: 0.1;
			width: rem(28);
			height: rem(28);
			position: absolute;
			left: 0;
			top: 0;
		}

		&--disabled {
			opacity: 0.5;
			cursor: default;
		}
	}

	&__control-arrow {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: rem(6);
		height: rem(12);
	}

	&__slider {
		padding: 0 0 0 rem(80);
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	&__slider-container {
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: flex-start;
		justify-content: flex-start;
		transition: transform 0.3s ease;
		padding-right: rem(80);
	}

	&__card {
		flex-shrink: 0;
		width: rem(268);
		height: rem(402);
		position: relative;
		cursor: pointer;
	}

	&__card-poster {
		width: rem(268);
		height: rem(402);
		position: relative;
	}

	&__card-img {
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__card-overlay {
		background: linear-gradient(180deg, rgba(13, 12, 15, 0) 0%, rgba(13, 12, 15, 0.1) 70.00821232795715%, rgba(13, 12, 15, 0.6) 79.78281378746033%, rgba(13, 12, 15, 1) 89.83963131904602%, rgba(13, 12, 15, 1) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	&__card-info {
		padding: 0 rem(16) rem(16) rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		position: absolute;
		left: 0;
		bottom: 0;
	}

	&__card-meta {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;
		overflow: hidden;
	}

	&__card-rating {
		border-radius: rem(16) 0 rem(16) 0;
		display: flex;
		flex-direction: row;
		gap: rem(8);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__card-star {
		width: rem(12);
		height: rem(12);
	}

	&__card-score {
		color: #ffaf00;
		text-align: left;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
		text-transform: uppercase;
	}

	&__card-separator {
		background: #ffffff;
		width: rem(1);
		height: rem(16);
		position: relative;
	}

	&__card-source {
		color: #ffffff;
		text-align: left;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 500;
		position: relative;
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.similar-movies {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.similar-movies {
		padding: 0 0 rem(30) 0;

		&__header {
			padding: 0 rem(16);
			flex-direction: column;
			align-items: flex-start;
		}

		&__title-wrapper {
			flex-direction: column;
			align-items: flex-start;
			gap: rem(16);
			width: 100%;
		}

		&__controls {
			display: none;
		}

		&__slider {
			padding: 0 0 0 rem(16);
			overflow-x: auto;
			-webkit-overflow-scrolling: touch;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		&__card {
			width: rem(200);
			height: rem(300);
		}

		&__card-poster {
			width: rem(200);
			height: rem(300);
		}
	}
}
</style> 